import React from 'react';
import Icon from '../components/Icon';

const changelogData = [
  {
    version: 'V2.5',
    date: '28 أكتوبر 2025',
    changes: [
      'تحسين أيقونة المشاركة بإضافة نافذة منبثقة لتأكيد النسخ.',
      'نقل أيقونة الوضع الليلي/النهاري إلى زر عائم في زاوية الشاشة.',
    ],
  },
  {
    version: 'V2.0',
    date: '25 أكتوبر 2025',
    changes: [
      'تحسين نموذج الذكاء الاصطناعي لإنشاء مستندات أكثر دقة واحترافية.',
      'إضافة 10 قوالب قانونية جديدة لتغطية احتياجات أوسع.',
      'تحسين سرعة تحميل التطبيق وأدائه العام لضمان تجربة سلسة.',
    ],
  },
  {
    version: 'V1.5',
    date: '18 سبتمبر 2025',
    changes: [
      'تجديد تصميم واجهة المستخدم لتحسين تجربة التصفح وجعلها أكثر حداثة.',
      'إضافة ميزة البحث والتصفية في صفحة "صفحاتي" لسهولة الوصول للمستندات.',
      'إضافة خيار لنسخ المحتوى كنص منسق (Markdown) بجانب النص العادي.',
      'تحسينات على مدقق بيانات النماذج لتقديم ملاحظات أوضح حول الأخطاء.',
    ],
  },
  {
    version: 'V1.0',
    date: '28 أغسطس 2025',
    changes: [
      'تمت إضافة بث المحتوى المباشر عند الإنشاء لتحسين تجربة المستخدم.',
      'تمكين المستخدمين من تعديل المحتوى الذي تم إنشاؤه مباشرة.',
      'إضافة خيار "نبرة الخطاب" للسماح بتخصيص مخرجات الذكاء الاصطناعي.',
      'إضافة صفحة سجل التغييرات هذه لتتبع التحديثات الجديدة.',
    ],
  },
  {
    version: 'V0.5',
    date: '15 يوليو 2025',
    changes: [
      'الإصدار الأولي للتطبيق مع وظائف إنشاء المستندات الأساسية.',
      'تمكين حفظ الصفحات المنشأة محليًا في المتصفح.',
      'توفير ميزة تبديل المظهر بين الوضع الفاتح والداكن.',
      'تصميم واجهة مستخدم سريعة الاستجابة لجميع الأجهزة.',
    ],
  },
];

const ChangelogPage: React.FC = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-[70px] py-12">
      <div className="max-w-4xl mx-auto">
        <header className="text-center mb-12">
          <div className="flex items-center justify-center gap-3">
            <Icon name="Clock" className="w-10 h-10 text-[var(--color-text-heading)]" />
            <h1 className="text-4xl md:text-5xl font-extrabold text-[var(--color-text-heading)]">
              سجل التغييرات
            </h1>
          </div>
          <p className="mt-4 text-lg text-[var(--color-text-body)] max-w-2xl mx-auto">
            تتبع جميع التحديثات والميزات الجديدة المضافة إلى منشئ الصفحات القانونية.
          </p>
        </header>

        <div className="space-y-8">
          {changelogData.map((item) => (
            <div key={item.version} className="bg-[var(--color-surface)] rounded-xl shadow-md border border-[var(--color-border)] p-6 sm:p-8">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-6">
                <h2 className="text-2xl font-bold text-[var(--color-text-heading)] mb-2 sm:mb-0">{item.version}</h2>
                <div className="text-sm px-3 py-1 rounded-full bg-black/5 dark:bg-white/10 text-[var(--color-text-body)] self-start">
                  {item.date}
                </div>
              </div>
              
              <ul className="space-y-4">
                {item.changes.map((change, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-[var(--color-success)] rounded-full flex items-center justify-center mt-0.5">
                      <Icon name="Check" className="w-4 h-4 text-[var(--color-white)]" />
                    </div>
                    <p className="text-[var(--color-text-body)]">{change}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChangelogPage;